<template>
  <div class="as-dropdown-toggle" v-if="dataFilterAll">
    <div class="as-dropdown-toggle__select">
      <div class="as-dropdown-toggle__select__as-head" @click="handleToggle" ref="selectHeader">
        <span>{{
          itemActive && itemActive?.id
            ? itemActive.name ?? itemActive.year ?? itemActive.title
            : "Tất cả"
        }}</span>
        <IconCustomArrownDown
          v-if="!isShow"
          fill="#2FB925"
          @click.stop="handleToggle"
        />
        <IconCustomArrownUp fill="#2FB925" v-else @click.stop="handleToggle" />
      </div>
      <div v-if="isShow" class="as-dropdown-toggle__select__as-body" ref="selectContent">
        <div
          v-for="(item, index) in dataFilterAll"
          :key="index"
          class="as-item-dropdown"
          :class="{
            'as-active': idActive === item.id
          }"
          @click="handleChoose(item)"
        >
          {{ item.name ?? item.year ?? item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, defineEmits } from "vue";
import { useClickOutside } from "~src/utils/clickOutsideHelper";
import IconCustomArrownDown from "~src/components/icons/IconCustomArrownDown.vue";
import IconCustomArrownUp from "~src/components/icons/IconCustomArrownUp.vue";
const emits = defineEmits(["handleChoose"]);

interface IProps {
  data: any[];
  idActive?: string | number;
  isFilterAll?: boolean;
}
interface Item {
  id: number | string;
  title?: string;
  name?: string;
  year?: string;
}
const props = withDefaults(defineProps<IProps>(), {});
const selectHeader = ref<HTMLElement | null>(null);
const selectContent = ref<HTMLElement | null>(null);
const itemActive = ref<Item | null>(
  props.idActive
    ? props.data.find((item: any) => item.id === props.idActive)
    : null
);
const isShow = ref(false);

const dataFilterAll = computed(() => {
  if (props.isFilterAll) {
    return [{ id: "", name: "Tất cả" }, ...props.data];
  }

  return props.data;
});

const handleToggle = () => {
  isShow.value = !isShow.value;
};
const handleChoose = (item: Item) => {
  itemActive.value = item;
  isShow.value = false;

  emits("handleChoose", item);
};

const closeCountrySelect = () => {
  isShow.value = false;
};

useClickOutside([selectHeader, selectContent], {
  handler: closeCountrySelect,
  middleware: (event) => {
    const target = event.target as HTMLElement;

    if (target.closest(".icon-arrow")) {
      return false;
    }

    return true;
  },
});
</script>

<script lang="ts">
export default {};
</script>

